import { create } from 'zustand'

interface ComposerPrefill {
  content?: string
  channelIds?: string[]
  scheduledAt?: number
  mediaIds?: string[]
  overrides?: Record<string, string>
  editId?: string
}

interface UIState {
  composerOpen: boolean
  composerPrefill: ComposerPrefill | null
  connectOpen: boolean
  openComposer: (prefill?: ComposerPrefill) => void
  closeComposer: () => void
  openConnect: () => void
  closeConnect: () => void
}

export const useUI = create<UIState>((set) => ({
  composerOpen: false,
  composerPrefill: null,
  connectOpen: false,
  openComposer: (prefill) => set({ composerOpen: true, composerPrefill: prefill || null }),
  closeComposer: () => set({ composerOpen: false, composerPrefill: null }),
  openConnect: () => set({ connectOpen: true }),
  closeConnect: () => set({ connectOpen: false }),
}))
